export default __webpack_public_path__ + "img/89eff06a.jpg";